import { styled } from '@mui/system';
import { ReactNode } from 'react';

const StyledCard = styled('div')<{ highlighted?: boolean; shadow?: boolean }>(
  ({ theme, highlighted, shadow }) => ({
    background: 'var(--background-background-color)',
    borderStyle: 'solid',
    borderWidth: highlighted ? 2 : 1,
    borderColor: highlighted
      ? theme.palette.primary.main
      : 'var(--stroke-stroke-primary-color)',
    borderRadius: theme.spacing(2),
    padding: `${theme.spacing(2.5)} ${theme.spacing(4)}`,
    flex: 1,
    width: '100%',
    boxShadow: `0  ${theme.spacing(0.5)} ${theme.spacing(1)} ${theme.spacing(
      -0.5
    )} rgba(0,0,0,0.1)`,
  })
);

export type CardProps = {
  children: ReactNode;
  highlighted?: boolean;
  shadow?: boolean;
  className?: string;
};

export const Card = ({
  children,
  className,
  shadow,
  highlighted,
}: CardProps) => {
  return (
    <StyledCard highlighted={highlighted} className={className} shadow={shadow}>
      {children}
    </StyledCard>
  );
};
